import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { Store } from '@ngxs/store';
import _ from 'lodash';
import { BehaviorSubject } from 'rxjs';
import { WellKnownIconsEnum } from 'src/app/helper/iconHelper';
import { SkillGroup } from 'src/app/store/samwin/samwin-skills/skill-group';
import { AgentGreetingSettingsSelector } from 'src/app/store/settings/agent-greeting-settings/agent-greeting-settings.selector';
import { AudioFileInfo } from 'src/app/store/settings/agent-greeting-settings/agent-greeting-settings.state';

@Component({
   selector: 'samweb-agent-greeting-wave-list',
   templateUrl: './agent-greeting-wave-list.component.html',
   styleUrls: ['./agent-greeting-wave-list.component.scss'],
})
export class AgentGreetingWaveListComponent {
   constructor(public store: Store) {}

   public clearIcon: IconDefinition = WellKnownIconsEnum.CLEAR.iconSmall;

   @Input()
   public availableDropZones: string[];

   @Input()
   public agentGreetings: AudioFileInfo[];

   @Input()
   public disabled = false;

   @Output()
   public waveDrop = new EventEmitter<CdkDragDrop<string[]>>();

   @Output()
   public removeWaveFile = new EventEmitter<AudioFileInfo>();

   @Output()
   public dragStarted = new EventEmitter<AudioFileInfo>();

   @Output()
   public dragEnded = new EventEmitter<AudioFileInfo>();

   public editedWave$ = new BehaviorSubject<number>(-1);

   public isDialogOpen$ = new BehaviorSubject<boolean>(false);

   public currentEntries$ = new BehaviorSubject<
      {
         skill: SkillGroup;
         iciName: string;
      }[]
   >([]);

   drop(event: CdkDragDrop<string[]>) {
      this.waveDrop.emit(event);
   }

   displayDialog(wave: AudioFileInfo) {
      const assignments = this.store.selectSnapshot(AgentGreetingSettingsSelector.getWaveAssignedGreetings)(wave.id);
      if (!_.isEmpty(assignments)) {
         this.editedWave$.next(wave.id);
         this.isDialogOpen$.next(true);
         this.currentEntries$.next(assignments);
         return;
      }
      this.removeWaveFile.emit(wave);
   }

   dialogClosed(wave: AudioFileInfo) {
      this.editedWave$.next(wave.id);
      this.isDialogOpen$.next(false);
   }

   removeWave(wave: AudioFileInfo) {
      this.removeWaveFile.emit(wave);
   }

   dragStart(wave: AudioFileInfo) {
      this.dragStarted.emit(wave);
      this.isDialogOpen$.next(false);
   }

   dragEnd(wave: AudioFileInfo) {
      this.dragEnded.emit(wave);
   }
}
